import React, { useEffect, useMemo } from 'react';
import { Font } from 'Vendor/Utils/StudioTypes';

interface FontFamilyDropdownProps {
  value: string;
  onChange: (family: string) => void;
  platformFonts?: Font[];
  label?: string;
}

const FontFamilyDropdown: React.FC<FontFamilyDropdownProps> = ({
  value,
  onChange,
  platformFonts = [],
  label,
}) => {
  const families = useMemo(() => {
    return platformFonts.map((f) => f.family).sort();
  }, [platformFonts]);

  useEffect(() => {
    if (!value && families.length > 0) {
      onChange(families[0]);
    }
  }, [value, families, onChange]);

  return (
    <div className="text-block-dropdown">
      {label && <label className="form-label fs-5 text-white">{label}</label>}
      <button
        className="btn btn-secondary dropdown-toggle w-100 text-start"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {value || families[0] || 'Select font'}
      </button>
      <ul className="dropdown-menu w-100">
        {families.map((family) => (
          <li key={family}>
            <button
              className="dropdown-item"
              type="button"
              onClick={() => onChange(family)}
            >
              {family}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FontFamilyDropdown;
